import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Target, Users, Zap, CheckCircle2, FileText, MapPin, Gift, Clock, Activity, Utensils, CloudRain, LifeBuoy, Calendar } from 'lucide-react';
export function ProductSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-white" data-id="element-215">
      {/* SECTION 4 - SYSTEM PRESENTATION */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-216">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-yellow-100 text-yellow-600 mb-6" data-id="element-217">
          <Target className="w-8 h-8" data-id="element-218" />
        </div>
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-slate-900 mb-4 uppercase" data-id="element-219">
          🏆 El Sistema N°1 para Profesores de Pádel Argentinos
        </h2>
        <p className="text-xl md:text-2xl text-slate-600 font-medium mb-12 max-w-3xl mx-auto" data-id="element-220">
          PADEL 360 — Colección Completa 12 Tomos + 6 Bonus + 2 Élite — Todo
          resuelto, todos los niveles.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-221">
          <StatBadge icon={<BookOpen className="w-6 h-6" data-id="element-223" />} text="+280 páginas" data-id="element-222" />
          <StatBadge icon={<Activity className="w-6 h-6" data-id="element-225" />} text="+120 ejercicios graficados en cancha" data-id="element-224" />
          <StatBadge icon={<Users className="w-6 h-6" data-id="element-227" />} text="Todos los niveles" data-id="element-226" />
          <StatBadge icon={<Zap className="w-6 h-6" data-id="element-229" />} text='Sistema "Abrí y Entrás"' data-id="element-228" />
        </div>
      </section>

      {/* SECTION 5 - LOS 12 TOMOS */}
      <section className="py-20 bg-slate-50 px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="max-w-7xl mx-auto" data-id="element-231">
          <div className="text-center mb-16" data-id="element-232">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-slate-900 mb-4 uppercase" data-id="element-233">
              Los 12 Tomos Completos
            </h2>
            <p className="text-xl text-slate-600 font-medium" data-id="element-234">
              Drills graficados · Por nivel y objetivo · Listo para usar mañana
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-235">
            <TomoCard num="1" title="Nivel Inicial — Fase 1" desc="El primer contacto real con la pala. Grip, posición, contacto y confianza desde el primer minuto." color="bg-blue-50 border-blue-200 text-blue-900" badgeColor="bg-blue-100 text-blue-800" data-id="element-236" />
            <TomoCard num="2" title="Nivel Inicial — Fase 2" desc="Del peloteo al juego real. Globo defensivo, volea básica y primer contacto con la pared." color="bg-blue-50 border-blue-200 text-blue-900" badgeColor="bg-blue-100 text-blue-800" data-id="element-237" />
            <TomoCard num="3" title="Intermedio 1 — Control y Posición" desc="Control direccional avanzado. Juego de fondo sistemático y movimiento de pareja sincronizado." color="bg-emerald-50 border-emerald-200 text-emerald-900" badgeColor="bg-emerald-100 text-emerald-800" data-id="element-238" />
            <TomoCard num="4" title="Intermedio 2 — Táctica de Pareja" desc="Sistema de red dominante. Coberturas, comunicación y cuándo bajar juntos de la red." color="bg-emerald-50 border-emerald-200 text-emerald-900" badgeColor="bg-emerald-100 text-emerald-800" data-id="element-239" />
            <TomoCard num="5" title="Avanzado 1 — Variantes Técnicas" desc="Bandeja, víbora, globo con efecto y remate por tres. El salto al juego de alto nivel." color="bg-purple-50 border-purple-200 text-purple-900" badgeColor="bg-purple-100 text-purple-800" data-id="element-240" />
            <TomoCard num="6" title="Avanzado 2 — Sistema de Juego Completo" desc="Sistema ofensivo completo. Lectura del rival, juego bajo presión y partido táctico dirigido." color="bg-purple-50 border-purple-200 text-purple-900" badgeColor="bg-purple-100 text-purple-800" data-id="element-241" />
            <TomoCard num="7" title="Adultos Mayores — Fase 1" desc="Pádel adaptado para cuerpos maduros. Movilidad, equilibrio, seguridad y disfrute real de la cancha." color="bg-orange-50 border-orange-200 text-orange-900" badgeColor="bg-orange-100 text-orange-800" data-id="element-242" />
            <TomoCard num="8" title="Adultos Mayores — Fase 2" desc="Juego de pareja adaptado, coordinación ojo-pala y torneo social seguro." color="bg-orange-50 border-orange-200 text-orange-900" badgeColor="bg-orange-100 text-orange-800" data-id="element-243" />
            <TomoCard num="9" title="Kids — Fase 1" desc="El pádel como juego. Coordinación, exploración lúdica y primer amor por la cancha." color="bg-pink-50 border-pink-200 text-pink-900" badgeColor="bg-pink-100 text-pink-800" data-id="element-244" />
            <TomoCard num="10" title="Kids — Fase 2" desc="Técnica lúdica y partido real con reglas adaptadas. El alumno que va a seguir jugando de grande." color="bg-pink-50 border-pink-200 text-pink-900" badgeColor="bg-pink-100 text-pink-800" data-id="element-245" />
            <TomoCard num="11" title="Lesiones — Prevención y Adaptación" desc="Protocolos para las 5 lesiones más comunes. Drills adaptados por zona y escalera de retorno al juego." color="bg-red-50 border-red-200 text-red-900" badgeColor="bg-red-100 text-red-800" data-id="element-246" />
            <TomoCard num="12" title="Lesiones — Casos Especiales y Alta Definitiva" desc="Posoperatorio, prótesis y patologías crónicas. El sistema para cuidar al alumno más fiel que tenés." color="bg-red-50 border-red-200 text-red-900" badgeColor="bg-red-100 text-red-800" data-id="element-247" />
          </div>

          <div className="mt-16 flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-248">
            <BadgeItem icon="✏️" text="Ejercicios graficados en cada tomo" data-id="element-249" />
            <BadgeItem icon="⚡" text='Sistema "Abrí y Entrás"' data-id="element-250" />
            <BadgeItem icon="📋" text="Fichas listas para imprimir" data-id="element-251" />
            <BadgeItem icon="🇦🇷" text="Contenido 100% adaptado a Argentina" data-id="element-252" />
          </div>

          {/* EXTRA CTA BUTTON AS REQUESTED */}
          <div className="mt-16 text-center" data-id="element-253">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-lg font-heading font-bold py-4 px-8 rounded-xl shadow-lg transition-all hover:-translate-y-1 uppercase tracking-wide" data-id="element-254">
              Ver opciones y precios <Zap className="w-5 h-5 text-yellow-400" data-id="element-255" />
            </button>
          </div>
        </div>
      </section>

      {/* SECTION 6 - LOS 6 BONUS */}
      <section className="py-20 bg-stone-50 px-4 sm:px-6 lg:px-8 relative" data-id="element-256">
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-257">
          <div className="text-center mb-12" data-id="element-258">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-slate-900 mb-4" data-id="element-259">
              + 6 Regalos Estratégicos
            </h2>
            <p className="text-lg text-slate-500 font-medium mb-8 max-w-md mx-auto" data-id="element-260">
              Incluidos sin costo extra · Valor real del pack
            </p>
            <div className="inline-flex items-center gap-2 bg-orange-400 text-white font-bold px-7 py-3.5 rounded-full text-base sm:text-lg shadow-lg shadow-orange-400/30" data-id="element-261">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-262">
            <BonusCard num="1" emoji="📊" bookColor="bg-rose-500" spineColor="bg-rose-700" icon={<Activity className="w-9 h-9 text-white/90" data-id="element-264" />} title="NIVELÓMETRO 360" desc="Ubicá a cualquier alumno en su nivel correcto en menos de 5 minutos. Nunca más adivines en qué tomo tiene que estar." data-id="element-263" />
            <BonusCard num="2" emoji="💪" bookColor="bg-orange-500" spineColor="bg-orange-700" icon={<Zap className="w-9 h-9 text-white/90" data-id="element-266" />} title="PREPARACIÓN FÍSICA DE 15 MINUTOS" desc="Rutinas específicas para el jugador de pádel. Sin gimnasio. Sin equipo. Solo vos, la cancha y el método." data-id="element-265" />
            <BonusCard num="3" emoji="🥗" bookColor="bg-emerald-600" spineColor="bg-emerald-800" icon={<Utensils className="w-9 h-9 text-white/90" data-id="element-268" />} title="NUTRICIÓN PARA EL JUGADOR DE PÁDEL" desc="Lo que comés decide el partido. Qué comer antes, durante y después. Sin dietas extremas. Sin suplementos caros." data-id="element-267" />
            <BonusCard num="4" emoji="🌧️" bookColor="bg-sky-500" spineColor="bg-sky-700" icon={<CloudRain className="w-9 h-9 text-white/90" data-id="element-270" />} title="PLAN PARA CUANDO LLUEVE" desc="La lluvia cancela la cancha, no la clase. 10 actividades de alto valor para el día que no hay cancha." data-id="element-269" />
            <BonusCard num="5" emoji="🆘" bookColor="bg-violet-600" spineColor="bg-violet-800" icon={<LifeBuoy className="w-9 h-9 text-white/90" data-id="element-272" />} title="KIT DE SUPERVIVENCIA DEL PROFE" desc="Grupos mixtos sin aviso, sin materiales, con 20 minutos o alumnos de mal humor. Protocolo de emergencia para cualquier situación." data-id="element-271" />
            <BonusCard num="6" emoji="📋" bookColor="bg-amber-500" spineColor="bg-amber-700" icon={<Calendar className="w-9 h-9 text-white/90" data-id="element-274" />} title="PACK DE ORGANIZACIÓN SEMANAL" desc="Planillas para eliminar la ansiedad del domingo. Tus clases, pagos, materiales y pendientes en una sola hoja." data-id="element-273" />
          </div>
        </div>
      </section>
    </div>;
}
function StatBadge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center p-6 bg-slate-50 rounded-2xl border border-slate-200" data-id="element-275">
      <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mb-4" data-id="element-276">
        {icon}
      </div>
      <p className="font-bold text-slate-800 text-lg leading-tight" data-id="element-277">{text}</p>
    </div>;
}
function TomoCard({
  num,
  title,
  desc,
  color,
  badgeColor
}: {
  num: string;
  title: string;
  desc: string;
  color: string;
  badgeColor: string;
}) {
  return <div className={`p-8 rounded-2xl border ${color} transition-transform hover:-translate-y-1 duration-300`} data-id="element-278">
      <div className={`inline-block px-3 py-1 rounded-md font-bold text-sm mb-4 ${badgeColor}`} data-id="element-279">
        TOMO {num}
      </div>
      <h3 className="text-xl font-heading font-bold mb-3 uppercase tracking-wide" data-id="element-280">
        {title}
      </h3>
      <p className="opacity-90 font-medium leading-relaxed" data-id="element-281">{desc}</p>
    </div>;
}
function BadgeItem({
  icon,
  text
}: {
  icon: string;
  text: string;
}) {
  return <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-slate-200" data-id="element-282">
      <span className="text-xl" data-id="element-283">{icon}</span>
      <span className="font-bold text-slate-700 text-sm" data-id="element-284">{text}</span>
    </div>;
}
function BonusCard({
  num,
  emoji,
  icon,
  bookColor,
  spineColor,
  title,
  desc
}: {
  num: string;
  emoji: string;
  icon: React.ReactNode;
  bookColor: string;
  spineColor: string;
  title: string;
  desc: string;
}) {
  return <div className="bg-white rounded-2xl p-8 shadow-sm border border-stone-200 hover:shadow-lg transition-shadow flex flex-col items-center text-center" data-id="element-285">
      {/* Book Mockup */}
      <div className="relative mb-6 mt-2" data-id="element-286">
        <div className={`relative w-40 h-52 ${bookColor} rounded-md shadow-xl overflow-hidden flex flex-col justify-between p-4 transform hover:scale-105 transition-transform`} data-id="element-287">
          {/* Spine */}
          <div className={`absolute left-0 top-0 bottom-0 w-3 ${spineColor}`} data-id="element-288"></div>
          {/* Page edge highlight */}
          <div className="absolute right-0 top-1 bottom-1 w-0.5 bg-white/30 rounded-full" data-id="element-289"></div>

          <div className="relative z-10 pl-3" data-id="element-290">
            {icon}
            <p className="text-white font-heading font-bold text-lg mt-3 leading-tight" data-id="element-291">
              Bonus {num}
            </p>
          </div>

          <div className="relative z-10 pl-3" data-id="element-292">
            <div className="w-12 h-px bg-white/40 mb-2" data-id="element-293"></div>
            <p className="text-white/80 text-[10px] font-bold tracking-widest" data-id="element-294">
              PADEL 360™
            </p>
          </div>
        </div>
      </div>

      {/* GRATIS Pill */}
      <div className="inline-block bg-emerald-100 text-emerald-700 font-bold text-xs tracking-wider px-3 py-1 rounded-full mb-4" data-id="element-295">
        GRATIS
      </div>

      <h3 className="text-xl font-heading font-bold text-slate-900 mb-3 leading-tight" data-id="element-296">
        <span className="mr-1" data-id="element-297">{emoji}</span> Bonus {num} — {title}
      </h3>
      <p className="text-slate-500 leading-relaxed" data-id="element-298">{desc}</p>
    </div>;
}